import { v4 as uuidv4 } from 'uuid';

// directive is meant to correct shortcomings in terms of accessibility of the buefy component library
// it adds the aria-live label in case of formfield errors appearing so that they are in the queue to be read by screen readers

export default {
  inserted(el) {
    if (!(el instanceof Node)) return;

    const input = el.querySelector('input');
    if (!input) return;

    const observer = new MutationObserver(() => {
      const errorMessage = el.querySelector('.help.is-danger');
      if (errorMessage) {
        if (!errorMessage.id) {
          const errorId = `error-${uuidv4()}`;
          errorMessage.setAttribute('id', errorId);
          errorMessage.setAttribute('role', 'alert');
          errorMessage.setAttribute('aria-live', 'assertive');
          input.setAttribute('aria-describedby', errorId);
        }
      } else {
        input.removeAttribute('aria-describedby');
      }
    });

    observer.observe(el, {
      childList: true,
      subtree: true,
    });

    el._accessibleErrorObserver = observer;
  },

  unbind(el) {
    if (el._accessibleErrorObserver) {
      el._accessibleErrorObserver.disconnect();
      delete el._accessibleErrorObserver;
    }
  },
};
